import { z } from "zod";

export const paymentTypes = ["stripe"] as const;
export type PaymentType = (typeof paymentTypes)[number];

export const paymentTypeOptions: Record<
  PaymentType,
  {
    title: string;
    logo: string;
    width: number;
    height: number;
    comingSoon: boolean;
  }
> = {
  stripe: {
    title: "Stripe",
    logo: "/images/stripe-logo.svg",
    width: 207,
    height: 52,
    comingSoon: false,
  },
};

export const posDevicePaymentTerminalSchema = z.object({
  type: z.literal("stripe"),
  locationId: z.string().min(1, "Location ID is required"),
  readerId: z.string().optional().default(""),
});

export type PosDevicePaymentTerminal = z.infer<
  typeof posDevicePaymentTerminalSchema
>;

export const EMPTY_POS_DEVICE_PAYMENT_TERMINAL: PosDevicePaymentTerminal = {
  type: "stripe",
  locationId: "",
  readerId: "",
};

export const toPosDevicePaymentTerminal = (
  terminal?: Partial<PosDevicePaymentTerminal> | null
): PosDevicePaymentTerminal => ({
  type: terminal?.type ?? EMPTY_POS_DEVICE_PAYMENT_TERMINAL.type,
  locationId:
    terminal?.locationId ?? EMPTY_POS_DEVICE_PAYMENT_TERMINAL.locationId,
  readerId: terminal?.readerId ?? EMPTY_POS_DEVICE_PAYMENT_TERMINAL.readerId,
});
